module.exports = __webpack_public_path__ + "img/greyStep.5b6b033c.svg";